import { AlertCircle } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/presentation/components/ui/alert-dialog';

interface ErrorConfirmDialogProps {
  open: boolean;
  onContinue: () => void;
  onAbort: () => void;
  title: string;
  description: string;
  continueLabel?: string;
  abortLabel?: string;
}

export function ErrorConfirmDialog({
  open,
  onContinue,
  onAbort,
  title,
  description,
  continueLabel = '続行',
  abortLabel = '中断',
}: ErrorConfirmDialogProps) {
  return (
    <AlertDialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onAbort();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertCircle className="h-5 w-5 text-red-500" />
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription className="whitespace-pre-wrap">
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onAbort}>{abortLabel}</AlertDialogCancel>
          <AlertDialogAction onClick={onContinue}>{continueLabel}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
